/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Group_Working_TogetherInputs */

const en_faq_group_working_together = /** @type {(inputs: Faq_Group_Working_TogetherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Working together`)
};

const lv_faq_group_working_together = /** @type {(inputs: Faq_Group_Working_TogetherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopīgs darbs`)
};

/**
* | output |
* | --- |
* | "Working together" |
*
* @param {Faq_Group_Working_TogetherInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_group_working_together = /** @type {((inputs?: Faq_Group_Working_TogetherInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Group_Working_TogetherInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_group_working_together(inputs)
	return en_faq_group_working_together(inputs)
});